import * as React from 'react';
import { Link } from 'react-router-dom';
import Icons from './Icons';
import { formatNumCommande } from './OrderAction';
import { Cart } from './iMonCompte';
import { renderEtatCommande, renderFilArianne, renderAlert, renderFileButton, renderNumCommande, renderDateCommande,
  renderMontantTTC, renderTitleH1, renderClaim, displayInvoice, renderCreditLinks,
  renderContainerTrackingLink } from './RenderCommon';
import {
  getUserId,
  getRole,
  formatPrice,
  getShopRefInStorage,
  sessionExpire,
} from './MonCompteAction';
import axios from 'axios';
import Modal from 'react-responsive-modal';
import {getFeatureEnabledPostprocessing, getHostApi, getRequestConfig, initEvent} from '../../utils';
import { RenderPointsRelais } from './RenderPointsRelais';
import RenderOrderDetailsLine from './RenderOrderDetailsLine';
import ButtonReOrder from './ButtonReOrder';

export default class RenderOrder extends React.Component<any, any> {
  constructor(params: any) {
    super(params);
    this.state = {
      motifsAnnulation: [],
      paymentMethods: [],
      changeDestinataire: false,
      nomLivraisonTmp: '',
      prenomLivraisonTmp: '',
      order: {
        Adresse1: '',
        Adresse1Livraison: '',
        Adresse2: '',
        Adresse3: '',
        Adresse2Livraison: '',
        Adresse3Livraison: '',
        CodePostal: '',
        CodePostalLivraison: '',
        DateCreationFacture: '',
        DateDeCommande: '',
        DateSouhaite: '',
        Email: '',
        Facture: '',
        ModeDeReglement: '',
        Nom: '',
        NomLivraison: '',
        Pays_idPays: '',
        Pays_idPaysLivraison: '',
        Prenom: '',
        PrenomLivraison: '',
        Prioritaire: '',
        Societe: '',
        SocieteLivraison: '',
        StatutCommande: '',
        TelephonePortable: '',
        cf: '',
        TotalTTC: '',
        Ville: '',
        VilleLivraison: '',
        idCommande: '',
        numCommande: '',
        numero_facture: '',
        prixHT: '',
        prixPortHT: '',
        taux_tva: '',
        transporteur: '',
        etat: {
          Etat: '',
          idEtat: '',
        },
        Signature: '',
        panier: [],
        prixTVA: '',
        remise: '',
        TotalHTSansRemise: '',
        confirmationFichier: '',
        retour_possible: false,
        PresenceGesteCommercial: true,
        nb_retours: 0,
        url_tracking: '',
        numColis: '',
        credits: [],
        Commentaires: '',
        sav: '',
        validation_bat: '',
      },
      showAlert: false,
      textAlert: 'Votre adresse a bien été mise à jour',
      classAlert: 'alert-success',
      open: false,
      motifAnnulation: '',
      autreMotif: '',
      isinternalUser: false,
      enabledPostProcessing: false
    };

    this._onUpdateInput = this._onUpdateInput.bind(this);
  }

  componentWillMount() {
    this._getOrder();
    this._getMotifsAnnulation();
    this._getActivationAnnulation();
    this._getActivationAnnulationAutreMoyenPaiment();
    getRole().then((role: any) => {
      if (role && role.role_id) {
        this.setState({ isinternalUser: true});
      }
    });
    getFeatureEnabledPostprocessing()
      .then(response => this.setState({ enabledPostProcessing: response.data?.feature ?? false}));
  }

  componentDidMount() {
    this._getOrder();
  }

  /**
   * Fonction retournant le détail d'une commande
   *
   * @private
   */
  _getOrder = () => {
    document.dispatchEvent(initEvent('dp-loading'));
    return axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.props.match.params.id}`, getRequestConfig())
      .then((response) => {
      if (response.data.order) {
        this.setState({ order: response.data.order, prenomLivraisonTmp: response.data.order.PrenomLivraison, nomLivraisonTmp: response.data.order.NomLivraison});
        document.dispatchEvent(initEvent('dp-loaded'));
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response?.status === 401) {
        sessionExpire();
      }
    });
  }

  _getMotifsAnnulation = () => {
    axios.get(`${getHostApi()}/shops/annulation-motifs`, getRequestConfig())
      .then((response) => {
      if (response.data.motifsAnnulation) {
        this.setState({ motifsAnnulation: response.data.motifsAnnulation });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _getActivationAnnulation() {
    axios.get(`${getHostApi()}/shops/features/compte_annulation_client`, getRequestConfig()).then((response) => {
      if (response.data.feature) {
        this.setState({ activateAnnulation: response.data.feature });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getActivationAnnulationAutreMoyenPaiment() {
    axios.get(`${getHostApi()}/shops/features/compte_annulation_client_autre_moyen_paiement`, getRequestConfig()).then((response) => {
      if (response.data.feature) {
        this.setState({ activateAnnulationAutreMoyenPaiement: response.data.feature });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  onOpenModalPR = () => {
    this.setState({ openPr: true });
  }

  onCloseModalPR = () => {
    this.setState({ openPr: false });
  }

  _renderModal() {
    return (
      <Modal open={this.state.open} onClose={this.onCloseModal} center
             classNames={{overlay: 'bootstrap-container', modal: 'cancelOrderModalContainer customModal',
               closeButton: 'cancelOrderModalCloseButton closeButton'}}>
        <div className="modalOrder p-2 pa0Mobile">
          <p>Etes-vous sûr de vouloir annuler la commande {formatNumCommande(this.state.order.numCommande)} ?</p>
          <button title="Annuler" onClick={this.onCloseModal}
                  className="border-0 bold bg-white1 cursor-pointer btnCancelModal float-left py-2 px-3">
            Non
          </button>
          <button title="Annuler la commande" onClick={() => { this._cancelOrder(); }}
                  className="border border-dark bold bg-white1 cursor-pointer btnValidateModal float-right py-2 px-3">
            Oui
          </button>
        </div>
      </Modal>
    );
  }

  _getFullAddress() {
    return this.state.order.Adresse1Livraison + ' ' + this.state.order.CodePostalLivraison + ' ' +
      this.state.order.VilleLivraison;
  }

  _updateOrderAddresses = (shippingPoint: any) => {
    const pr = {
      id: this.state.order.commande_adresse_pr_id,
      nom: shippingPoint.name,
      numero: shippingPoint.id,
      adresse1: shippingPoint.street,
      code_postal: shippingPoint.zipCode,
      ville: shippingPoint.city,
      latitude: shippingPoint.coordinatesGPS.lat,
      longitude: shippingPoint.coordinatesGPS.lng,
      transporteur: shippingPoint.transporteur,
    };

    return axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/addresses`,
      { shippingPoint: pr, type: 'pointRelais' }, getRequestConfig())
      .then((response) => {
        this.setState({
          showAlert: true,
          openPr: false,
          classAlert: 'alert-success',
          textAlert:  'Le point relais a bien été modifié',
        }, () => {
          this._getOrder()
          .then(() => {
            if(this.state.isinternalUser && this.state.order.dropshipping) {
              this._testLabel();
            }
          })
        });
      }).catch((error) => {
        if (error.response.status === 401) {
          sessionExpire();
        } else {
          this.setState({
            showAlert: true,
            textAlert: error.response.data.message,
            classAlert: 'alert-danger',
          });
        }
      });
  }

  _onPrClick = (shippingPoint: any) => {
    this._updateOrderAddresses(shippingPoint);
  }

  _testLabel = () => {
    document.dispatchEvent(new Event('dp-loading'));
    document.getElementsByClassName('textLoader')[0]?.innerText = "Validation de l'étiquette de transport...";
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/test-label`;

    axios.post(url, { 
      numCmd: this.state.order.numCommande?.split('-')[2],
      signature: this.state.order.Signature,
      orderId: this.state.order.idCommande
    }, getRequestConfig())
    .then(res => this.setState({ textAlert: res.data.message, classAlert: 'alert-success' }))
    .catch((err) => {
      this.setState({
        showAlert: true,
        textAlert: err.response.data.message,
        classAlert: 'alert-danger',
      });
    }).finally(() => {
      document.getElementsByClassName('textLoader')[0]?.innerText = 'Chargement...';
      document.dispatchEvent(new Event('dp-loaded'));
    })
  }

  _onChangeAutreMotif = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ autreMotif: event.target.value });
  }

  _onChangeMotifAnnulation = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ motifAnnulation: event.target.value });
    const textarea = document.getElementById('autre_motif');

    if(!textarea) return;

    if (event.target.value === '10') {
      textarea.style.display = 'block';
    } else {
      textarea.style.display = 'none';
    }

  }

  _cancelOrder = () => {
    if (this.state.activateAnnulation && this.state.order.annulationInfo &&
      this.state.order.annulationInfo.isPossible === 'Oui') {
      if ((this.state.motifsAnnulation.length > 0 && this.state.motifAnnulation !== '' &&
        (parseInt(this.state.motifAnnulation) !== 10 ||
          (parseInt(this.state.motifAnnulation) === 10 && this.state.autreMotif !== ''))) ||
        (this.state.motifsAnnulation.length === 0 && this.state.autreMotif !== '')) {
        this.onCloseModal();

        const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/cancel`;
        axios.put(url, { motif: this.state.motifAnnulation, autreMotif: this.state.autreMotif }, getRequestConfig()).then((response) => {
          this.setState({
            showAlert: true,
            textAlert: 'Votre commande a bien été annulée !',
            classAlert: 'alert-success',
          }, () => {
            this._getOrder();
          });
        }).catch((error) => {
          console.log(error);
        });
      }else {
        this.setState({
          showAlert: true,
          classAlert: 'alert-danger',
          textAlert: 'Pour annuler votre commande, merci de bien vouloir nous indiquer la raison.',
        });
      }
    } else {
      this.setState({
        showAlert: true,
        classAlert: 'alert-danger',
        textAlert: 'Pour annuler votre commande, merci de bien vouloir nous indiquer la raison.',
      });
    }
  }

  _onUpdateInput = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    if (type == 'PrenomLivraison' && event.target.value !==  this.state.prenomLivraisonTmp) {
      this.setState({prenomLivraisonTmp: event.target.value, changeDestinataire: event.target.value.length > 0});
    } else if (type == 'NomLivraison' && event.target.value !==  this.state.nomLivraisonTmp) {
      this.setState({nomLivraisonTmp: event.target.value, changeDestinataire: event.target.value.length > 0});
    } else {
      this.setState({changeDestinataire: false});
    }
  }

  _updateNomPrenomLivraison = () => {
    const valPrenom = this.state.prenomLivraisonTmp;
    const valNom = this.state.nomLivraisonTmp;
    if(valPrenom && valPrenom && this.state.changeDestinataire) {
      axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${this.state.order.idCommande}/addresses`,
        { nom: valNom.toString(), prenom: valPrenom.toString(), type: 'livraison' }, getRequestConfig())
        .then((response) => {
          this.setState({
            showAlert: true,
            openPr: false,
            classAlert: 'alert-success',
            textAlert:  'Le destinataire du colis a bien été modifié',
          }, () => {
            this._getOrder();
          });
        }).catch((error) => {
        if (error.response.status === 401) {
          sessionExpire();
        } else {
          this.setState({
            showAlert: true,
            openPr: false,
            textAlert: error.response.data.message,
            classAlert: 'alert-danger',
          });
        }
      });
    }
  }

  render() {
    const renderModalPR = () => {
      if (this.state.order) {
        return (
          <Modal open={this.state.openPr} onClose={this.onCloseModalPR} center
                 classNames={{overlay: 'bootstrap-container', modal: 'pointsRelaisModalContainer customModal',
                   closeButton: 'pointsRelaisModalCloseButton closeButton'}}>
            <div className="modalPR p-2" style={{ maxHeight: '740px' }}>
              <div className="p-2 border bg-lightgrey rounded text-center mb-3">
                <p className={"m-0 font12 text-secondary text-left text-uppercase"}>Destinataire</p>
                <label className="mr-2 font14 mb-0">Prénom :</label>
                <input  className={`mr-4  ${this.state.prenomLivraisonTmp.length < 1  ? 'borderRed outlineRed' : ''}`} type="text" name="prenomLivraison" id="prenomLivraison"  maxLength={12} onChange={e => this._onUpdateInput(e, 'PrenomLivraison')} value={this.state.prenomLivraisonTmp}  />
                <label className="mr-2 font14 mb-0">Nom :</label>
                <input  className={`  ${this.state.nomLivraisonTmp.length < 1  ? 'borderRed outlineRed' : ''}`}  type="text" name="nomLivraison" maxLength={14}   id="nomLivraison" onChange={e => this._onUpdateInput(e, 'NomLivraison')} value={this.state.nomLivraisonTmp} />
                <button disabled={!this.state.changeDestinataire} className={`ml-4  white bg-blue btn border-0 ${!this.state.changeDestinataire ? 'disabled' : ''}`}
                        onClick={this._updateNomPrenomLivraison}> Modifier le destinataire </button>
              </div>
              <RenderPointsRelais orderId={this.state.order.idCommande}
                        onPrClick={this._onPrClick}
                        defaultAddress={this._getFullAddress()}
                        showButtons={true} />
            </div>
          </Modal>
        );
      }
    };

    const renderListItems = this.state.order.panier.map((panier: Cart) => {
      if (parseInt(this.state.order.cf) !== 1) {
        return (
          <div key={panier.idCaddies} className="row-item py-3 border-bottom">
            <RenderOrderDetailsLine panier={panier} sav={this.state.order.sav} order={this.state.order} enabledPostProcessing={this.state.enabledPostProcessing} />
          </div>
        );
      }
    });

    const renderDetailsOrder = () => {
      let commentaire = '';
      let hideIfCF = 'd-none';
      if (parseInt(this.state.order.cf) === 1) {
        commentaire = this.state.order.Commentaires ;
        hideIfCF = '';
      }

      return (
        <div className="black">
          <div className="font16 mt-4 mb-2">
            <span className="bold"> Contenu de la commande&nbsp;</span>
            {renderNumCommande(this.state.order.numCommande)}
          </div>
          <div className={'border py-3 text-center ' + hideIfCF } >
            <span className="">&nbsp;{commentaire}</span>
          </div>
          <div className="">
            {renderListItems}
          </div>
        </div>
      );
    };

    const renderMontantHT = () => {
      return (
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="col-md-8 col-9 p-0">Montant total des produits HT :&nbsp;</div>
          <div className="col-md-4 col-3 pr-0 text-right">{formatPrice(this.state.order.TotalHTSansRemise)} &euro;</div>
        </div>
      );
    };

    const renderRemise = () => {
      if (parseInt(this.state.order.remise,10) !== 0) {
        return (
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="col-md-8 col-9 p-0">Montant total des remises HT :&nbsp;</div>
            <div className="col-md-4 col-3 pr-0 text-right">{formatPrice(this.state.order.remise)} &euro;</div>
          </div>
        );
      }
    };

    const renderMontantTransportHT = () => {
      if (parseInt(this.state.order.prixPortHT,10) !== 0) {
        return (
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="col-md-8 col-9 p-0">Frais de conditionnement et de transport HT :&nbsp;</div>
            <div className="col-md-4 col-3 pr-0 text-right">{formatPrice(this.state.order.prixPortHT)} &euro;</div>
          </div>
        );
      }
    };

    const renderMontantTVAHT = () => {
      if (parseInt(this.state.order.prixTVA,10) !== 0) {
        return (
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="col-md-8 col-9 p-0">T.V.A. :&nbsp;</div>
            <div className="col-md-4 col-3 pr-0 text-right">{formatPrice(this.state.order.prixTVA)} &euro;</div>
          </div>
        );
      }
    };

    const renderMontantTTCDetails = () => {
      return (
        <div className="d-flex justify-content-between align-items-center bold">
          <div className="col-md-8 col-9 p-0">Montant total de la commande TTC :&nbsp;</div>
          {renderMontantTTC(this.state.order.TotalTTC, true)}
        </div>
      );
    };

    const renderTransporteur = () => {
      let transportCmd = this.state.order.transporteur;
      if (transportCmd === 'EXAPAQ') {
        transportCmd = 'DPD';
      }
      return (<div className="col-md-12 mt-3 italic p-0">Envoi de la commande par {transportCmd}</div>);
    };

    const renderMontantsOrder = () => {
      if (parseInt(this.state.order.sav) === 0) {
        return (
          <div className="py-3 black font14 blocMontantDetail">
            {renderMontantHT()}
            {renderRemise()}
            {renderMontantTransportHT()}
            {renderMontantTVAHT()}
            {renderMontantTTCDetails()}
            {this.state.order.orderDelayTypeLabel && (
              <div className="col-md-12 mt-3 italic p-0">
                Type de délai : <span className="text-capitalize">{this.state.order.orderDelayTypeLabel}</span>
              </div>
            )}
            {renderTransporteur()}
          </div>
        );
      }
    };

    const renderAvertissement = () => {
      if (parseInt(this.state.order.confirmationFichier) === 1) {
        return (
          <div className="mt-3">
            <p className="grey text-center italic">
              Vous avez attesté avoir les droits d'exploitation des fichiers fournis.
            </p>
          </div>
        );
      }
    };

    const renderEditButton = (text: 'phones' | 'livraison' | 'facturation' | 'email') => {
      const statutLimit = this.state.isinternalUser && text !== 'facturation'  ? '8' : '7';
      if (this.state.order.StatutCommande < statutLimit && ((!this.state.order.commande_adresse_pr_id) ||
        (this.state.order.commande_adresse_pr_id && (text === 'facturation' || text === 'phones' || text === 'email')))) {
        let link = '/addresses/address/' + text + '/' + this.state.order.idCommande;
        if (text === 'email') {
          link = '/profil';
        }

        return (
          <div className="text-left">
            <Link to={`${link}`} title="Editer l'adresse" >
              <button className="bg-white pl-2 cursor-pointer "
                      style={{ border: 'none', borderRadius: '30px' }}>
                <span className="pr-1">
                  <Icons icon="edit_address" size={15} color="black" />
                </span>
                <span>Modifier</span>
              </button>
            </Link>
          </div>
        );
      }
    };

    const renderBillingAddress = () => {
      const modify = this.state.order.paysFacturation.livraisons_pro_uniquement !== "1" &&
          !this.state.order.numTVAIntraco;
      return (
        <div className="black col-md-6 pl-0 orderDetailAddresses">
          <p className="bold mb-2">Adresse de facturation :</p>
          <div className="">
            <div className="pl-2 border-left mb-2">
              <p className="mb-0">{this.state.order.Societe}</p>
              <p className="mb-0">{this.state.order.Prenom} {this.state.order.Nom}</p>
              <p className="mb-0">{this.state.order.Adresse1}</p>
              <p className="mb-0">{this.state.order.Adresse2}</p>
              <p className="mb-0">
                {this.state.order.CodePostal}&nbsp;
                <span className="text-uppercase">{this.state.order.Ville}</span>
              </p>
              <p className="text-uppercase">
                <img src={`/order/images/flags/${this.state.order.paysFacturation.codePays}.png`} className={"mr05"}/>
                {this.state.order.paysFacturation.Libelle}
              </p>
            </div>
            {modify && renderEditButton('facturation')}
          </div>
        </div>
      );
    };

    const renderPR = () => {
      const modifyDropshipping = this.state.isinternalUser && this.state.order.dropshipping;
      if (this.state.order.commande_adresse_pr_id && (parseInt(this.state.order.StatutCommande) < 7 || modifyDropshipping)) {
        return (
          <div className="text-left">
            <button className="bg-white pl-2 cursor-pointer d-flex"
                    style={{ border: 'none', borderRadius: '30px' }}
                    onClick={this.onOpenModalPR}>
              <span className="pr-1">
                <Icons icon="edit_address" size={15} color="black" />
              </span>
              <span className="text-left">Modifier mon point relais</span>
            </button>
            {renderModalPR()}
          </div>
        );
      }
    };

    const renderDeliveryAddress = () => {
      if (this.state.order.cf !== '1') {
        let text = 'Adresse de livraison :';
        if (this.state.order.commande_adresse_pr_id) {
          text = ' Adresse du point relais :';
        }

        const modify = this.state.order.paysFacturation.livraisons_pro_uniquement !== "1" &&
            !this.state.order.numTVAIntraco;
        const modifyDropshipping = this.state.isinternalUser && this.state.order.dropshipping; 

        return (
          <div className="black col-md-6 pl-0 orderDetailAddresses">
            <p className="bold mb-2">{text}</p>
            <div>
              <div className="pl-2 border-left mb-2">
                <p className="mb-0">{this.state.order.SocieteLivraison}</p>
                <p className="mb-0">{this.state.order.commande_adresse_pr_id ? '' : `${this.state.order.PrenomLivraison} ${this.state.order.NomLivraison}`}</p>
                <p className="mb-0">{this.state.order.Adresse1Livraison}</p>
                <p className="mb-0">{this.state.order.commande_adresse_pr_id ? '' :
                  this.state.order.Adresse2Livraison}</p>
                <p className="mb-0">{this.state.order.CodePostalLivraison}&nbsp;
                  <span className="text-uppercase">{this.state.order.VilleLivraison}</span>
                </p>
                <p className="text-uppercase">
                  <img src={`/order/images/flags/${this.state.order.paysLivraison.codePays}.png`} className={"mr05"}/>
                  {this.state.order.paysLivraison.Libelle}
                </p>
              </div>
              {(modify || modifyDropshipping) && renderEditButton('livraison')}
              {renderPR()}
            </div>
          </div>
        );
      }
    };

    const renderAddresses = () => {
      return (
        <div className="d-flex align-items-start col-md-6 pl-0 flex-column-mobile pa0Mobile">
          {renderBillingAddress()}
          {renderDeliveryAddress()}
        </div>
      );
    };

    const renderHistory = () => {
      if (this.state.order.logs && this.state.order.logs.length > 0) {
        return (
          <div style={{ display: 'inline-block' }}>
            <Link to={`/orders/${this.state.order.idCommande}/chronology`}
                  className="d-flex align-items-center black cursor-pointer border-black p-2 bg-white text-center"
                  style={{ borderRadius: '30px', border: '1px solid' }}>
              <span className="pr-1"><Icons icon="history" size={20} color="#333" /></span>
              <span>Suivi de commande</span>
            </Link>
          </div>
        );
      }
    };

    const renderCancelOrderLink = () => {
      if (this.state.order.annulationInfo
        && this.state.order.annulationInfo.isPossible === 'Oui'
        && this.state.activateAnnulation
        && this.state.order.sav != "1"
        && this.state.activateAnnulation == 1) {
          if ((this.state.order.ModeDeReglement !== 'Cheque' && this.state.order.ModeDeReglement !== 'Chèque' && this.state.order.ModeDeReglement !== 'Virement' && this.state.order.ModeDeReglement !== 'Virement Administration') || this.state.activateAnnulationAutreMoyenPaiement) {
            return (
                <div className="mt-3 text-right">
                  <a onClick={ this.onOpenModal } className="cursor-pointer d-flex align-items-center text-left">
                    <Icons icon="delete_address" size={ 12 } color="#333"/>
                    <span className="pl-1">Annuler votre commande</span>
                  </a>
                </div>
            );
          }
      }
    };

    const renderOptionsMotifs = () => {
      const motifs = [];
      motifs.push(
        <option key="motif-0" value="" selected className="grey italic">Sélectionnez la raison de votre annulation</option>,
      );

      for (const motif of this.state.motifsAnnulation.reverse()) {
        let isSelected = false;
        if (parseInt(motif.droits) === 0 && parseInt(motif.is_avoir) === 0) {
          if (this.state.motifAnnulation == motif.id) {
            isSelected = true;
          }
            motifs.push(<option key={`motif-${motif.id}`} id={motif.id} selected={isSelected}  value={motif.id}>{motif.motif}</option>);
        }
      }
      return motifs;
    };

    const renderSelectMotifs = () => {
      if (this.state.motifsAnnulation.length > 0) {
        return (
          <div className="mb-3">
            <select id="motifAnnulation" name="motifAnnulation" onChange={(e: any) => this._onChangeMotifAnnulation(e)}>
              {renderOptionsMotifs()}
            </select>
          </div>
        );
      }
    };

    const renderTextareaMotif = () => {
      const defineDisplay = () => {
        if (this.state.motifsAnnulation.length === 0) {
          return 'block';
        }
        return 'none';
      };

      return (
        <div className="mb-3">
          <textarea placeholder="Précisez la raison de votre annulation" name="autre_motif" id="autre_motif"
                    cols={70} style={{ display: defineDisplay() }} onChange={e => this._onChangeAutreMotif(e)}>
          </textarea>
        </div>
      );
    };

    const renderCancelModal = () => {
      return (
        <Modal open={ this.state.open } onClose={ this.onCloseModal } center
               classNames={{overlay: 'bootstrap-container', modal: 'cancelOrderModalContainer customModal',
                 closeButton: 'cancelOrderModalCloseButton closeButton'}}>
          <div className="modalOrder p-3 pa0Mobile">
            <p className="bold text-underline font18">
              Etes-vous sûr de vouloir annuler la commande {formatNumCommande(this.state.order.numCommande)} ?
            </p>
            {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
            {renderSelectMotifs()}
            {renderTextareaMotif()}
            <button title="Annuler" onClick={ this.onCloseModal }
                    className="border-0 bold bg-white1 cursor-pointer btnCancelModal float-left py-2 px-3">
              Non
            </button>
            <button title="Annuler la commande" onClick={ this._cancelOrder }
                    className="border-dark bold bg-white1 cursor-pointer btnValidateModal float-right py-2 px-3">
              Oui
            </button>
          </div>
        </Modal>
      );
    };

    const renderHistoryAndCancelButtons = () => {
      return (
        <div className="text-right col-md-3 pl-0">
          { renderHistory() }
          <ButtonReOrder
            shopRef={getShopRefInStorage()}
            items={this.state.order.panier}
          />
          { renderCancelOrderLink() }
          { renderCancelModal() }
        </div>
      );
    }

    const renderLandlinePhone = () => {
      let text = 'NC';
      if (this.state.order.TelephoneFixe && this.state.order.TelephoneFixe !== '') {
        text = this.state.order.TelephoneFixe;
      }

      return (
        <p className="p-0 m-0">
          <span>Tél. : </span>
          <span>{text}</span>
        </p>
      );
    };

    const renderMobilePhone = () => {
      let text = 'NC';
      if (this.state.order.TelephonePortable !== '') {
        text = this.state.order.TelephonePortable;
      }

      return (
        <p className="p-0 m-0">
          <span>Tél. portable : </span>
          <span>{text}</span>
        </p>
      );
    };

    const renderPhones = () => {
      return (
        <div className="black col-md-3 orderDetailAddresses pa0Mobile">
          <p className="bold mb-2">Coordonnées tél. :</p>
          <div>
            <div className="pl-2 border-left mb-2">
              {renderLandlinePhone()}
              {renderMobilePhone()}
            </div>
            {renderEditButton('phones')}
          </div>
          <p className="bold mb-2 mt-3">Coordonnées Email :</p>
          <div>
            <div className="pl-2 border-left mb-2">
              { this.state.order.Email }
            </div>
            {renderEditButton('email')}
          </div>
        </div>
      );
    };

    const renderPDF = () => {
      if (this.state.order.credits || parseInt(this.state.order.Facture) === 1) {
        return (
          <div className="col-md-6 pl-0 d-flex flex-column">
            <div>
              {displayInvoice(this.state.order)}
            </div>
            <div className="">
              {renderCreditLinks(this.state.order)}
            </div>
          </div>
        );
      }
    };

    const renderPDFAndHistory = () => {
      return (
        <div className="d-flex align-items-center pb-3">
          {renderPDF()}
        </div>
      );
    };

    const displayFileInfos = () => {
      if ((getShopRefInStorage() === 'TE' || getShopRefInStorage() === 'TO') && parseInt(this.state.order.cf) !== 1) {
        return (
          <div className="d-flex align-items-center mt-3 mb-2">
            {renderFileButton(this.state.order, true)}
          </div>
        );
      }
    };

    const renderMontantTotal = () => {
      if (parseInt(this.state.order.sav) === 1) {
        return (
          <div className="text-center font14 col-md-4 p-0">
            <Icons icon="build" size={12} color="#333" /> Commande issue d'une réclamation
          </div>
        );
      }
      return renderMontantTTC(this.state.order.TotalTTC, true);
    };

    const renderOrder = () => {
      return (
        <div>
          <div className="font14">
            {renderDateCommande(this.state.order.numCommande, this.state.order.DateDeCommande, 'Commande du ')}
            {renderClaim(this.state.order)}
            <div>
              {renderContainerTrackingLink(this.state.order.url_tracking, this.state.order.numColis,
                                           this.state.order.cf, this.state.order.StatutCommande, this.state.order.colis)}
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-top mt-2">
            <div className="col-md-8 pl-0">
              {renderEtatCommande(
                this.state.order.StatutCommande,
                this.state.order.etat.Etat,
                this.state.order.validation_bat,
                this.state.order.confirmationFichier,
                this.state.order.MarquageClair,
                this.state.order.AucunMarquage
                )}
            </div>
            {renderMontantTotal()}
          </div>
          {renderPDFAndHistory()}
          <div className={'d-flex flex-column flex-md-row align-items-start border-dark border' +
          ' border-left-0 border-right-0 py-3'}>
            {renderAddresses()}
            {renderPhones()}
            {renderHistoryAndCancelButtons()}
          </div>
          {displayFileInfos()}
          {renderDetailsOrder()}
          {renderMontantsOrder()}
          {renderAvertissement()}
        </div>
      );
    };

    return (
      <div>
        {this.state.order.idCommande &&
        <div>
          {renderTitleH1('commandes', 'Commande ' + formatNumCommande(this.state.order.numCommande))}
          {renderFilArianne(<Link className="grey" to={`/orders`}>Mes commandes</Link>, 'Détail de ma commande')}
          {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
          {renderOrder()}
        </div>
        }
      </div>
    );
  }
}
